import { tStatic } from "./i18n";
/* CSV export helper — generates a CSV string from rows of plain objects and
 * triggers a download. Values are coerced to strings, commas / quotes / line
 * breaks are escaped per RFC 4180. */

function cell(v) {
  if (v === null || v === undefined) return "";
  let s;
  if (Array.isArray(v) || (typeof v === "object" && v !== null)) {
    try { s = JSON.stringify(v); } catch { s = String(v); }
  } else {
    s = String(v);
  }
  if (s.includes(",") || s.includes('"') || s.includes("\n") || s.includes("\r")) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

/**
 * @param {string} filename - file name with .csv extension
 * @param {Array<Object>} rows - array of objects (one per CSV row)
 * @param {Array<{key:string,label?:string}>} [columns] - explicit column order;
 *                                                       defaults to keys of first row
 */
export function exportCsv(filename, rows, columns = null) {
  if (!rows || rows.length === 0) {
    alert(tStatic("common.nothing_export"));
    return;
  }
  const cols = columns || Object.keys(rows[0]).map((k) => ({ key: k, label: k }));
  const header = cols.map((c) => cell(c.label || c.key)).join(",");
  const body = rows.map((r) => cols.map((c) => cell(r[c.key])).join(",")).join("\r\n");
  // BOM keeps Excel happy with UTF-8 characters (€, ç, ã…)
  const csv = "\ufeff" + header + "\r\n" + body;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
